<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content" v-menu-permission="'list'">
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi" ref="emListFilter"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="emSppRequisitionSprResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table :entity="modelName" inlineActionsDisabled :query-api="$_emWorkflowListMixin_queryApi"
                        :ref="modelName+'Table'" import-enabled checkboxColumnDisabled editDisable withCustomRowActions>
                <template slot="customRowActions" slot-scope="customRowScope">
                  <b-button-group>
                    <em-button type="task"
                               v-bind:class="'btn btn-outline-primary btn-sm'"
                               @click="$_emWorkflowListMixin_handleApprove(customRowScope.row)" custom-label="工作流任务">
                    </em-button>

                    <b-button-group>
                      <em-button type="gotoChild"
                                 v-bind:class="'btn btn-outline-primary btn-sm'"
                                 @click="gotoChild(customRowScope.row)" custom-label="备件详情录入/查看">
                      </em-button>
                    </b-button-group>

                  </b-button-group>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
  </div>
</template>
<script>
  // Author thq
  // Date 2021-01-03 10:11:10
  import emWorkflowListMixin from "@/mixin/em/workflow/list";
  import emCommonGotoMixin from "@/mixin/em/common/goto";

  export default {
    name: "emSppRequisitionSprWorkflowListView",
    mixins: [emWorkflowListMixin,emCommonGotoMixin],
    computed: {
      modelName() {
        return this.$_emRouterHelperMixin_entityName
      }
    },
    methods: {
      gotoChild(row) {
        //参数 isInline=true  fromParent 行编辑
        //    isInline=false  fromOtherList 窗口编辑
        //    urlParam 地址栏自定义传递参数
        this.$_emGotoMixin_gotoHolderList("emSppRequisitionDetSrd",
            {srdIdSprFilter: row.id},
            {srdIdSpr: row.id},
            false,
            {mainId:row.id})
      }
    }
  };
</script>
